/* import __COLOCATED_TEMPLATE__ from './fly-dropdown-toggle.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
/**
  fly-dropdown-toggle is a component used with non-native dropdowns to control
  the user’s action of opening a dropdown.

  @class FlyDropdownToggle
  @public
 */
let FlyDropdownToggle = (_class = class FlyDropdownToggle extends Component {
  onClick() {
    if (this.args.onClick != null) {
      this.args.onClick();
    }
  }
  onFocusOut() {
    if (this.args.onFocusOut != null) {
      this.args.onFocusOut();
    }
  }
  onKeyDown(event) {
    let {
      key
    } = event;
    if (key === 'Enter') {
      if (this.args.onEnterPressed != null) {
        this.args.onEnterPressed();
      }
      return false;
    }
    if (key === 'Escape' || key === 'Tab') {
      if (this.args.collapseAction != null) {
        this.args.collapseAction();
      }
      return;
    }
    if (key === 'ArrowDown' || key === 'ArrowUp') {
      event.preventDefault();
    }
    if (this.args.onKeyDown != null) {
      this.args.onKeyDown(event);
    }
    return;
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onFocusOut", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFocusOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeyDown"), _class.prototype)), _class);
export { FlyDropdownToggle as default };